import React, { Fragment } from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import moment from 'moment'
import Cleave from 'cleave.js'
import DeleteConfirmationModal from './DeleteConfirmationModal'
import Modal from '../common/Modal'
import Tooltip from '../common/Tooltip'
import UpsertOutstandingLoan from './queries/UpsertOutstandingLoan'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 100px 130px 200px 90px 85px;
  position: relative;
  padding: 5px 0px;
`
const EditContainer = Container.extend`
  padding: 8px 0px;
`
const Value = styled.span`
  align-self: center;
  padding: 8px 0;
`
const Exclamation = styled.i`
  color: #dd6a01;
  position: relative;
  align-self: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
`
const Select = styled.select`
  width: calc(100% - 6px);
  align-self: center;
  padding: 4px;
`
const SelectSmall = styled.select`
  width: calc(56% - 6px);
  padding: 4px;
  margin-left: 6px !important;
`
const Controls = styled.div`
  display: flex;
  justify-content: end;
  gap: 12px;
  border-top: 1px solid #DDDDDE;
  border-bottom: 1px solid #DDDDDE;
  padding: 8px 0;
`
const Lender = styled.input`
  width: calc(100% - 6px);
  align-self: center;
`
const Input = styled.input`
  width: calc(100% - 6px);
  align-self: center;
  border: 1px solid #ccc !important;
  border-radius: 4px;
  height: 20px;
  padding: 4px 6px;
`
const OriginationDate = Input.extend`
  height: 30px;
`
const OutstandingPrincipal = Input.extend`
  height: 30px;
`
const MinimumPayment = Input.extend`
  width: 40%;
  height: 30px;
`
const PaymentsRemaining = Input.extend`
  height: 30px;
`
const Label = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0px;
`
const Checkbox = styled.input`
  margin: 0px 5px 0px 0px !important; /* Bootstrap override -_- */
`
const Cancel = styled.button`
  cursor: pointer;
  border: 1px solid #0000003D;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 14px;
  font-weight: 600;
`
const Save = styled.button`
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background: #56565A;
`
const EditButtonContainer = styled.div`
  position: absolute;
  right: 0px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 8px);
  padding: 3px 4px;
  justify-content: space-between;
  visibility: hidden;
  ${Container}:hover & {
    visibility: visible;
  }
`
const EditButtons = styled.div`
  position: relative;
  overflow: visible;
  height: 100%;
`
const CircleButton = styled.i`
  background: #e2813b;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  padding: 2px;
  text-align: center;
  position: absolute;
  right: 3px;
  ${({ top }) => top ? 'top: calc(50% + 4px);' : ''}
  ${({ bottom }) => bottom ? 'bottom: calc(50% + 3px);' : ''}
`
const suggestedMonthsRemaining = {
  'Flooring Line': 50,
  'Credit Card': 50,
  'Line of Credit': 50
}
export class DebtRow extends React.Component {
  constructor(props) {
    super(props)
    let loanProps = {}
    if (props.loan) {
      const {
        debtType,
        lender,
        originationDate,
        principalBalance,
        monthsRemaining,
        refinance,
        minimumPayment,
        paymentFrequency
      } = props.loan
      loanProps = {
        debtType,
        lender,
        originationDate: moment(originationDate).format('YYYY'),
        outstandingPrincipal: principalBalance,
        monthsRemaining,
        refinance,
        minimumPayment,
        paymentFrequency
      }
    }
    this.state = {
      isHovered: false,
      debtType: null,
      lender: null,
      originationDate: null,
      outstandingPrincipal: null,
      monthsRemaining: null,
      minimumPayment: null,
      paymentFrequency: null,
      refinance: false,
      outstandingPrincipalCleave: null,
      minimumPaymentCleave: null,
      paymentsRemainingCleave: null,
      originationDateCleave: null,
      isDeleteModalOpen: false,
      ...loanProps
    }
  }
  componentDidMount() {
    if (this.isNewDebt) {
      this.setupCleaves()
    }
  }
  componentWillUnmount() {
    if (this.isNewDebt) {
      this.destroyCleaves()
    }
  }
  componentDidUpdate(prevProps) {
    const { isEditable, loan } = this.props
    const { isEditable: isPrevEditable } = prevProps
    if (!isPrevEditable && isEditable && loan) {
      this.setupCleaves()
      if (loan) {
        const {
          debtType,
          lender,
          originationDate,
          principalBalance,
          monthsRemaining,
          refinance,
          minimumPayment,
          paymentFrequency
        } = this.props.loan
        this.setState({
          isHovered: false,
          debtType,
          lender,
          originationDate: moment(originationDate).format('YYYY'),
          outstandingPrincipal: principalBalance,
          monthsRemaining,
          refinance,
          minimumPayment,
          paymentFrequency
        })
      }
    }
  }
  get isNewDebt() {
    const { newDebt } = this.props
    return newDebt
  }
  get isIncludedInDSCR() {
    const { monthsRemainingCutoff, loan } = this.props
    const { refinance, monthsRemaining, active } = loan
    const notIncluded = refinance || !active || monthsRemaining < monthsRemainingCutoff + 1
    return !notIncluded
  }
  get paymentOptions() {
    return [
      ['Daily', 'daily'],
      ['Weekly', 'weekly'],
      ['Twice a Month', 'bi_weekly'],
      ['Monthly', 'monthly']
    ]
  }
  get isSaveDisabled() {
    const { loanTypeOptions } = this.props
    const { paymentOptions } = this
    const { 
      debtType, 
      lender, 
      originationDate, 
      outstandingPrincipal, 
      monthsRemaining, 
      minimumPayment, 
      paymentFrequency 
    } = this.state
    const isNan = value => {
      return Number.isNaN(value)
    }
    const isOriginationNotValid = !moment(originationDate, 'YYYY', true).isValid() || moment(originationDate, 'YYYY', true).isBefore(moment('1998', 'YYYY'))
    let valid = true
    if (!loanTypeOptions.includes(debtType)) {
      valid = false
    } else if(!paymentOptions.map(([,v]) => v).includes(paymentFrequency)) {
      valid = false
    } else if (typeof lender !== 'string' || lender.length < 1) {
      valid = false
    } else if (isOriginationNotValid) {
      valid = false
    } else if (isNan(parseFloat(outstandingPrincipal)) || outstandingPrincipal < 1) {
      valid = false
    } else if (isNan(parseFloat(minimumPayment)) || minimumPayment < 0) {
      valid = false
    } else if (isNan(parseInt(monthsRemaining, 10)) || monthsRemaining <= 0) {
      valid = false
    }
    return !valid
  }
  setupCleaves = () => {
    const commonCleave = {
      numeral: true,
      numeralPositiveOnly: true,
      stripLeadingZeroes: true
    }
    const decimalOptions = {
      numeralDecimalScale: 2,
      ...commonCleave
    }
    const integerOptions = {
      numeralDecimalScale: 0,
      ...commonCleave
    }
    // Use the native JS Cleave class due to a bug with the Cleave React component improperly setting cursor position
    this.setState({
      outstandingPrincipalCleave: new Cleave('#outstanding-principal', {
        ...decimalOptions,
        onValueChanged: e => this.onNumberChange(e, 'outstandingPrincipal', 'float')
      }),
      minimumPaymentCleave: new Cleave('#minimum-payment', {
        ...decimalOptions,
        onValueChanged: e => this.onNumberChange(e, 'minimumPayment', 'float')
      }),
      paymentsRemainingCleave: new Cleave('#payments-remaining', {
        ...integerOptions,
        onValueChanged: e => this.onNumberChange(e, 'monthsRemaining', 'int')
      }),
      originationDateCleave: new Cleave('#origination-date', {
        date: true,
        datePattern: ['Y'],
        onValueChanged: e => this.setState({ originationDate: e.target.value })
      })
    })
  }
  onNumberChange = (e, key, type) => {
    const {rawValue } = e.target
    let val = parseFloat(rawValue)
    if (type === 'int') {
      val = parseInt(rawValue, 10)
    }
    this.setState({ [key]: val })
  }
  destroyCleaves = () => {
    this.state.outstandingPrincipalCleave.destroy()
    this.state.minimumPaymentCleave.destroy()
    this.state.paymentsRemainingCleave.destroy()
    this.state.originationDateCleave.destroy()
  }
  reset = () => {
    this.setState({
      debtType: null,
      lender: null,
      originationDate: null,
      outstandingPrincipal: null,
      monthsRemaining: null,
      minimumPayment: null,
      paymentFrequency: null,
      refinance: false
    })
  }
  enableEdit = () => {
    const { loan, enableEdit } = this.props
    enableEdit(loan.rid)
  }
  disableEdit = () => {
    this.props.disableEditableDebt()
  }
  
  toggleDeleteModal = () => {
    this.setState({ isDeleteModalOpen: !this.state.isDeleteModalOpen })
  }
  onDeleteClick = () => {
    this.toggleDeleteModal()
  }
  _onSave = async () => {
    const { upsertOutstandingLoan, refetch, businessId, loan, financialReviewRefetch } = this.props
    const {
      debtType,
      lender,
      originationDate,
      outstandingPrincipal,
      monthsRemaining,
      refinance,
      minimumPayment,
      paymentFrequency
    } = this.state
    if (!this.isSaveDisabled) {
      const outstandingLoanId = !this.isNewDebt ? loan.rid : null
      const outstandingLoanFields = {
        debtType,
        lender,
        originationDate: moment(originationDate, 'YYYY').toISOString(),
        principalBalance: outstandingPrincipal,
        monthsRemaining: parseInt(monthsRemaining, 10),
        monthlyPayment: null,
        minimumPayment,
        paymentFrequency,
        refinance
      }
      try {
        await upsertOutstandingLoan({
          variables: {
            input: {
              businessId,
              outstandingLoanId,
              outstandingLoanFields
            }
          },
          update: () => {
            // Reset fields as soon as the mutation has completed to avoid race condition
            this.reset()
          }
        })
        refetch()
        financialReviewRefetch()
        this.onCancel()
      } catch (err) {
        console.error(err)
      }
    }
  }
  onCancel = () => {
    this.props.onCancel()
  }
  onPaymentTypeChange = e => {
    const { value } = e.target
    this.setState({ paymentFrequency: value })
  }
  onDebtTypeChange = e => {
    const { newDebt } = this.props
    const { debtType, monthsRemaining } = this.state
    const { value } = e.target
    const shouldMonthsRemainingNull = !(value in suggestedMonthsRemaining) &&
                                        debtType in suggestedMonthsRemaining &&
                                        monthsRemaining === suggestedMonthsRemaining[debtType] &&
                                        newDebt
    // Only use suggested months remaining if the user is creating a new debt
    if (value in suggestedMonthsRemaining && newDebt && !monthsRemaining) {
      this.setState({
        debtType: value,
        monthsRemaining: suggestedMonthsRemaining[value]
      })
      this.state.paymentsRemainingCleave.setRawValue(suggestedMonthsRemaining[value])
    } else if (shouldMonthsRemainingNull) {
      // Reset if user switches to another debt type without changing months remaining
      this.setState({
        debtType: value,
        monthsRemaining: null
      })
      this.state.paymentsRemainingCleave.setRawValue()
    } else {
      this.setState({ debtType: value })
    }
  }
  renderDeleteConfirmation = () => {
    const { loan, refetch, financialReviewRefetch } = this.props
    const { isDeleteModalOpen } = this.state
    return (
      <Modal light isModalOpen={isDeleteModalOpen}>
        <DeleteConfirmationModal
          rid={loan.rid}
          toggleModal={this.toggleDeleteModal}
          refetch={refetch}
          financialReviewRefetch={financialReviewRefetch}
        />
      </Modal>
    )
  }
  renderIncludedInDSCR = () => {
    if (this.isIncludedInDSCR) {
      return 'Yes'
    } else {
      return (
        <span>
          No &nbsp;
          <Exclamation
            innerRef={el => this.exclamation = el}
            className="fa fa-exclamation-circle"
            onMouseOver={() => this.setState({ isHovered: true })}
            onMouseOut={() => this.setState({ isHovered: false })}
          >
            {this.renderTooltip()}
          </Exclamation>
        </span>
      )
    }
  }
  renderEditButtons = () => {
    return (
      <EditButtonContainer>
        <EditButtons>
          <CircleButton bottom onClick={this.enableEdit} className="fa fa-pencil" />
          <CircleButton top onClick={this.onDeleteClick} className="fa fa-trash" />
        </EditButtons>
      </EditButtonContainer>
    )
  }
  renderTooltip = () => {
    const { monthsRemainingCutoff } = this.props
    const { refinance, monthsRemaining, active } = this.props.loan
    let text
    if (refinance) {
      text = 'This debt will be refinanced with the SmartBiz SBA loan.'
    } else if (!active) {
      text = 'This debt is not active'
    } else if (monthsRemaining < monthsRemainingCutoff + 1) {
      text = `This debt has less than ${monthsRemainingCutoff + 1} payments remaining.`
    }
    if (this.state.isHovered) {
      return (
        <Tooltip
          visible={this.state.isHovered}
          bottomEdge={this.exclamation.getBoundingClientRect().height + 10}
          right="100%"
        >
          {text}
        </Tooltip>
      )
    }
  }
  renderPaymentTypes = () => {
    const { paymentOptions } = this
    return paymentOptions.map(([label, value]) => <option key={value} value={value}>{label}</option>)
  }
  renderDebtTypes = () => {
    const { loanTypeOptions } = this.props
    return loanTypeOptions.map(type => <option key={type} value={type}>{type}</option>)
  }
  render() {
    const { loan, isEditable, id } = this.props
    const { paymentOptions } = this

    if (!isEditable) {
      const {
        debtType, lender, originationDate, principalBalance, minimumPayment, monthsRemaining, paymentFrequency, monthlyPayment,
      } = loan
      const [paymentFrequencyTitle] = paymentFrequency ? paymentOptions.find(([,v]) => v === paymentFrequency) : ['']

      return (
        <Fragment>
          <Container innerRef={node => this.container = node} id={id}>
            <Value>{debtType}</Value>
            <Value>{lender}</Value>
            <Value>{moment(originationDate).format('YYYY')}</Value>
            <Value>${principalBalance ? principalBalance.toLocaleString() : ''}</Value>
            <Value>
              ${minimumPayment ? minimumPayment.toLocaleString() : ''} {paymentFrequencyTitle}
              {paymentFrequency !== 'monthly' && (
                <Fragment>
                  <br />
                  <span>${monthlyPayment.toLocaleString()} Monthly</span>
                </Fragment>
              )}
            </Value>
            <Value>{monthsRemaining}</Value>
            <Value>{this.renderIncludedInDSCR()}</Value>
            {this.renderEditButtons()}
          </Container>
          {this.renderDeleteConfirmation()}
        </Fragment>
      )
    } else {
      return (
        <>
          <EditContainer id={id}>
            <Select
              defaultValue={loan ? loan.debtType : ''}
              onChange={this.onDebtTypeChange}
              className="debt_row_cell"
            >
              <option value="1">Select Type</option>
              {this.renderDebtTypes()}
            </Select>
            <Lender
              defaultValue={loan ? loan.lender : ''}
              type="text"
              onChange={e => this.setState({ lender: e.target.value })}
              className="debt_row_cell"
            />
            <OriginationDate
              defaultValue={loan && moment(loan.originationDate).format('YYYY')}
              placeHolder="YYYY"
              onChange={e => this.setState({ originationDate: e.target.value })}
              id="origination-date"
              className="debt_row_cell"
            />
            <OutstandingPrincipal
              defaultValue={loan ? loan.principalBalance : ''}
              id="outstanding-principal"
              className="debt_row_cell"
            />
            <div>
              <MinimumPayment
                defaultValue={loan ? loan.minimumPayment : ''}
                id="minimum-payment"
                className="debt_row_cell"
              />
              <SelectSmall
                defaultValue={loan ? loan.paymentFrequency : ''}
                onChange={this.onPaymentTypeChange}
                className="debt_row_cell"
              >
                <option value="1">Select Type</option>
                {this.renderPaymentTypes()}
              </SelectSmall>
            </div>
            <PaymentsRemaining
              defaultValue={loan ? loan.monthsRemaining : ''}
              id="payments-remaining"
              className="debt_row_cell"
              onChange={e => this.onNumberChange(e, 'monthsRemaining', 'int')}
              ref={node => this.paymentsRemaining = node}
            />
            <Label htmlFor='refinance'>
              <Checkbox id='refinance'
                defaultChecked={loan ? loan.refinance : false}
                type="checkbox"
                onChange={e => this.setState({ refinance: e.target.checked })}
                className="debt_row_cell"
              />
              Refinance
            </Label>
          </EditContainer>
          <Controls>
            <Cancel onClick={this.onCancel}>Cancel</Cancel>
            <Save disabled={this.isSaveDisabled} onClick={this._onSave}>Save</Save>
          </Controls>
        </>
      )
    }
  }
}

export default graphql(UpsertOutstandingLoan, {
  name: 'upsertOutstandingLoan'
})(DebtRow)
